// Generated by genversion.
export const version = '6.1.2';
//# sourceMappingURL=version.js.map